import { Trial } from "@/typedef/trial";

type Props = {
  step: number | null;
  trial: Trial;
  trialPractice: { id: number; name: string } | null;
  userId?: string;
};

export const stepsHelper = ({ step, trial, trialPractice, userId }: Props) => {
  const steps = [
    {
      id: 0,
      title: "Account Info",
      header: "Account Information",
      description:
        "Create an account to monitor your Pets' progress through the application process.",
      visible: !userId,
    },
    {
      id: 1,
      title: "Select a Study Site",
      header: "Select a Study Site",
      description: `Please select a study location you would like to participate at for ${trial.name}.`,
      visible: trial.practices.length > 0 && !trialPractice,
    },
    {
      id: 2,
      title: "Pet Info",
      header: "Pet Information",
      description: "Please select an existing pet to apply or add a new one.",
      visible: true,
    },
    {
      id: 3,
      title: "Medical Info",
      header: "Medical Information",
      description: "",
      visible: true,
    },
    {
      id: 4,
      title: "Contact Info",
      header: "Contact Information",
      description: "Please enter your contact information.",
      visible: true,
    },
    {
      id: 5,
      title: "Review",
      header: "Summary",
      description: "Please ensure the following information you have submitted is correct.",
      visible: true,
    },
  ].filter((step) => step.visible !== false);

  const currentStepIndex = step ? step - 1 : 0;
  const nextStepIndex = (step ?? 1) + 1;
  const prevStepIndex = (step ?? 1) - 1;
  const currentStep = steps[currentStepIndex];
  const isFirst = currentStepIndex === 0;
  const isLast = currentStepIndex === steps.length - 1;

  return {
    currentStep,
    nextStepIndex,
    prevStepIndex,
    isFirst,
    isLast,
    steps,
  } as const;
};
